// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"794":"a64e7f8a","872":"5d069cbd"}[chunkId] + ".chunk.js";
};